import ApiService from './ApiService'

export const CaldavService = {
  baseURL: process.env.VUE_APP_EBOOKING_URL,

  getUserCaldav (params = {}) {
    return new Promise((resolve, reject) => {
      ApiService.query(`${this.baseURL}/caldav`, params)
        .then(response => resolve(response.data.data))
        .catch(error => reject(error))
    })
  },

  create (params = {}) {
    return new Promise((resolve, reject) => {
      ApiService.post(`${this.baseURL}/caldav`, params)
        .then(response => resolve(response.data.data))
        .catch(errors => reject(errors))
    })
  },

  refresh (caldavId, params = {}) {
    return new Promise((resolve, reject) => {
      ApiService.post(`${this.baseURL}/caldav/${caldavId}`, params)
        .then(response => resolve(response.data.data))
        .catch(errors => reject(errors))
    })
  },

}

export const AvailabilityService = {

  baseURL: process.env.VUE_APP_EBOOKING_URL,

  query (params) {
    return new Promise((resolve, reject) => {
      ApiService.query(`${this.baseURL}/availabilities`, params)
        .then(response => resolve(response.data.data))
        .catch(error => reject(error))
    })
  },

  cancelableQuery (params, cancelationCallback) {
    return new Promise((resolve, reject) => {
      ApiService.cancelableQuery(`${this.baseURL}/availabilities`, params, cancelationCallback)
        .then(response => resolve(response.data.data))
        .catch(error => reject(error))
    })
  },

  store (params) {
    return new Promise((resolve, reject) => {
      ApiService.post(`${this.baseURL}/availabilities`, params)
        .then(response => resolve(response.data.data))
        .catch(errors => reject(errors))
    })
  },

  update (slug, params) {
    return new Promise((resolve, reject) => {
      ApiService.patch(`${this.baseURL}/availabilities/${slug}`, params)
        .then(response => resolve(response.data.data))
        .catch(errors => reject(errors))
    })
  },

  getAppointments (slug, params) {
    return new Promise((resolve, reject) => {
      ApiService.query(`${this.baseURL}/availabilities/${slug}/appointments`, params)
        .then(response => resolve(response.data.data))
        .catch(errors => reject(errors))
    })
  },

  sendQRCodeNotification (slug, params) {
    return ApiService.post(`${this.baseURL}/availabilities/${slug}/qr-code`, params)
  },

  delete (slug, params = {}) {
    return ApiService.delete(`${this.baseURL}/availabilities/${slug}`, params)
  }
}
export const FacilityService = {

  baseURL: process.env.VUE_APP_EBOOKING_URL,

  access (params) {
    return new Promise((resolve, reject) => {
      ApiService.query(`${this.baseURL}/facilitiesaccess`, params)
        .then(response => resolve(response.data.data))
        .catch(errors => reject(errors))
    })
  },

  activities (params) {
    return new Promise((resolve, reject) => {
      ApiService.query(`${this.baseURL}/facilitiesactivities`, params)
        .then(response => resolve(response.data.data))
        .catch(errors => reject(errors))
    })
  },

  workActivities (facilityId, params) {
    return new Promise((resolve, reject) => {
      ApiService.query(`${this.baseURL}/facilities/${facilityId}/work-activities`, params)
        .then((response) => resolve(response.data.data))
        .catch((errors) => reject(errors))
    })
  }
}

export const ScreeningService = {

  baseURL: process.env.VUE_APP_EBOOKING_URL,

  query (params) {
    return new Promise((resolve, reject) => {
      ApiService.query(`${this.baseURL}/availabilities`, params)
        .then(response => resolve(response.data.data))
        .catch(errors => reject(errors))
    })
  },

  getAnswers (slug) {
    return new Promise((resolve, reject) => {
      ApiService.query(`${this.baseURL}/screenings/${slug}/questions`)
        .then(response => resolve(response.data.data))
        .catch(errors => reject(errors))
    })
  }
}

export const QuestionService = {

  baseURL: process.env.VUE_APP_EBOOKING_URL,

  get (slug) {
    return new Promise((resolve, reject) => {
      ApiService.query(`${this.baseURL}/entities/${slug}/questions`)
        .then(response => resolve(response.data.data))
        .catch(errors => reject(errors))
    })
  }
}

export const ReportService = {

  baseURL: process.env.VUE_APP_EBOOKING_URL,

  get (slug) {
    return new Promise((resolve, reject) => {
      ApiService.query(`${this.baseURL}/screenings/${slug}/report`)
        .then(response => resolve(response.data.data))
        .catch(errors => reject(errors))
    })
  },

  store (slug, params) {
    return new Promise((resolve, reject) => {
      ApiService.post(`${this.baseURL}/screenings/${slug}/close`, params)
        .then(response => resolve(response.data.data))
        .catch(errors => reject(errors))
    })
  },

  update (slug, params) {
    return new Promise((resolve, reject) => {
      ApiService.patch(`${this.baseURL}/reports/${slug}`, params)
        .then(response => resolve(response.data.data))
        .catch(errors => reject(errors))
    })
  },

  delete (slug) {
    return new Promise ((resolve, reject) => {
      ApiService.delete(`${this.baseURL}/reports/${slug}`)
        .then(response => resolve(response.data.data))
        .catch(errors => reject(errors))
    })
  },

  excel (report) {
    return new Promise((resolve, reject) => {
      ApiService.blob(`${this.baseURL}/reports/${report.id}/download-excel`,)
        .then(response => resolve(response.data))
        .catch(errors => reject(errors))
    })
  }
}

export const AppointmentService = {

  baseURL: process.env.VUE_APP_EBOOKING_URL,

  store (params) {
    return new Promise((resolve, reject) => {
      ApiService.post(`${this.baseURL}/appointments`, params)
        .then(response => resolve(response.data.data))
        .catch(errors => reject(errors))
    })
  },

  update (slug, params) {
    return new Promise((resolve, reject) => {
      ApiService.patch(`${this.baseURL}/appointments/${slug}`, params)
        .then(response => resolve(response.data.data))
        .catch(errors => reject(errors))
    })
  },

  delete (slug) {
    return ApiService.delete(`${this.baseURL}/appointments/${slug}`)
  }
}

export const StatisticsService = {

  baseURL: process.env.VUE_APP_EBOOKING_URL,

  getPromoterStats (params) {
    return new Promise((resolve, reject) => {
      ApiService.query(`${this.baseURL}/promoterstatistics`, params)
        .then(response => resolve(response.data.data))
        .catch(errors => reject(errors))
    })
  },

  getAppointmentStatistics (params) {
    return new Promise((resolve, reject) => {
      ApiService.query(`${this.baseURL}/statistics`, params)
        .then(response => resolve(response.data.data))
        .catch(errors => reject(errors))
    })
  }
}
